export type ArrayElement<ArrayType extends readonly unknown[]> =
  ArrayType[number];

export const INTERNAL_HREF_PATTERN: ArrayElement<Inputs>["regex"] = {
  pattern: `^/.*`,
  options: "g",
  message: "You must use href starting with '/...' ",
};

export const IMAGE_FILE_TYPES = ["jpeg", "jpg", "png", "gif", "svg", "webp"];

export const VIDEO_FILE_TYPES = ["mp4", "mov"];

export const PRODUCTS_BINDING = {
  "component.options.products": "state.products",
} as const;

export const PRODUCTS_BINDING_INPUT = {
  name: "products",
  type: "object",
} as const;

export const BUILDER_FRAME_EDITING_SEARCH_PARAM = "builder.frameEditing";

export const BUILDER_TEXT_CLASSNAME = "builder-text";
